import React, { useState } from 'react';

const ConfirmPopupHOC = (Component: any) =>
  function Comp(props: any) {
    const [showConfirmPopup, setShowConfirmPopup] = useState<boolean>(false);

    const confirmPopupToggleHandler = () => {
      setShowConfirmPopup(!showConfirmPopup);
    };

    return (
      <Component
        showConfirmPopup={showConfirmPopup}
        confirmPopupToggleHandler={confirmPopupToggleHandler}
        {...props}
      />
    );
  };

export default ConfirmPopupHOC;
